module.exports = __webpack_public_path__ + "/images/cover-retailers-box-fr.10a37de.png";